interface QueryFetchState {
  isLoading: boolean;
  isFetching: boolean;
}

/**
 * True only while there is no cached data yet to show: the very first load, or a
 * refetch (e.g. arg change) that cleared `currentData`. Once data exists, a
 * background `isFetching` does not count as loading.
 */
export const isInitialLoad = (query: QueryFetchState, data: unknown): boolean =>
  query.isLoading || (query.isFetching && data == null);
